import { render, staticRenderFns } from "./UserN_Details.vue?vue&type=template&id=1515c2e4"
import script from "./UserN_Details.vue?vue&type=script&lang=js"
export * from "./UserN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports